const ITEMS = [
    "Gold · XAU/USD",
    "WTI Crude Oil",
    "S&P 500",
    "Silver",
    "ETF Strategies",
    "Forex Signals",
    "Algorithmic Bots",
    "Trading Education",
];

const Row = () => (
    <div className="flex shrink-0 items-center">
        {ITEMS.map((item) => (
            <span key={item} className="flex items-center">
                <span className="px-10 font-editorial italic font-light text-2xl md:text-4xl text-zinc-400 whitespace-nowrap">
                    {item}
                </span>
                <span className="h-2 w-2 rotate-45 bg-gold/70 shrink-0" aria-hidden="true" />
            </span>
        ))}
    </div>
);

const Marquee = () => (
    <section
        data-testid="editorial-marquee"
        className="group relative overflow-hidden border-y border-white/10 bg-coal/40 py-8 md:py-10"
        aria-hidden="true"
    >
        <div className="flex w-max animate-marquee group-hover:[animation-play-state:paused]">
            <Row />
            <Row />
        </div>
    </section>
);

export default Marquee;
